

import React, { useState } from 'react';
import {
    Input,
    FormGroup,
    Button,
    Label, Col, Row

} from "reactstrap";
import { useNavigate } from 'react-router-dom';
import { Field } from 'formik';
import { CustomButton } from 'components/CommonInputs/CustomButtons/CustomButton';

const RejectCandidate = ({ closeModal }) => {
    // const [selectedOption, setSelectedOption] = useState('');
    const navigate = useNavigate();

    // const handleContinue = () => {
    //     if (selectedOption === 'existing') {
    //         navigate('/existing-candidates');
    //     }
    //     else if(selectedOption === 'new'){
    //         navigate('/new-candidates');
    //     }
    //     else{
    //         navigate('/submitted-candidates')
    //     }
    //     // Add logic for "new" if needed
    // };

    return (
        <div
            style={{
                minWidth: '640px',
                borderRadius: '32px',
                backgroundColor: '#fff',
                boxShadow: '0px 4px 20px rgba(0,0,0,0.1)',
                padding: '32px',
            }}
        >
            <p
                className='heading'
                style={{
                    fontWeight: 700,
                    fontSize: '24px',
                    lineHeight: '28px',
                    marginBottom: '24px'
                }}
            >
                Reject Candidate
            </p>

            <Row>
                <Col>
                    <FormGroup>
                        <Label style={{
                            color: "#344054",
                            fontWeight: 500,
                            fontSize: '14px',
                            lineHeight: '20px',
                            letterSpacing: '0%',
                        }}>Screening Round</Label>
                        <Input type='select' width="30px" style={{}}>
                            <option value="">Select</option>
                        </Input>
                    </FormGroup>
                </Col>
            </Row>
            <Row > 
                <p style={{
                    color: "#222222",
                    fontWeight: 700,
                    fontSize: '14px',
                    lineHeight: '20px',
                    letterSpacing: '0%',
                }}>
                    Select a reason for rejection
                </p>
                <Col >
                    <FormGroup className='d-flex gap-2 '>
                    <Input id='1' className='checkbox' type="checkbox" style={{border:"1px solid #475467"}} />
                        <Label for='1' style={{
                            fontFamily: 'Inter, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                            lineHeight: '22px',
                            // letterSpacing: '0%',
                            textAlign:"center"
                        }}>Not a skill match</Label>
                    </FormGroup>
                    <FormGroup className='d-flex gap-2 align-items: center'>
                    <Input id='2' className='checkbox' type="checkbox" style={{border:"1px solid #475467"}} />
                        <Label for='2' style={{
                            fontFamily: 'Inter, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                            lineHeight: '22px',
                            // letterSpacing: '0%'
                        }}>Experience below expectations</Label>
                    </FormGroup>
                    <FormGroup className='d-flex gap-2 align-items: center'>
                    <Input id='3' className='checkbox' type="checkbox" style={{border:"1px solid #475467"}} />
                        <Label for='3' style={{
                            fontFamily: 'Inter, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                            lineHeight: '22px',
                            // letterSpacing: '0%'
                        }}>Poor resume presentation</Label>
                    </FormGroup>
                    <FormGroup className='d-flex gap-2 align-items: center'>
                    <Input id='4' className='checkbox' type="checkbox" style={{border:"1px solid #475467"}} />
                        <Label for='4' style={{
                            fontFamily: 'Inter, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                            lineHeight: '22px',
                            // letterSpacing: '0%'
                        }}>No relevant project work</Label>
                    </FormGroup>
                    <FormGroup className='d-flex gap-2 align-items: center'>
                    <Input id='5' className='checkbox' type="checkbox" style={{border:"1px solid #475467"}} />
                        <Label for='5' style={{
                            fontFamily: 'Inter, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                            lineHeight: '22px',
                            // letterSpacing: '0%'
                        }}>Others</Label>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
               <Row className=''>
               <p className='mb-2' style={{
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '-20px',
//   letterSpacing: '0%'
  }}>
                Additional Comments 
                </p>
                <p style={{
  fontWeight: 500,
  fontStyle: 'italic',
  fontSize: '10px',
  lineHeight: '-12px',
  color:"#475467",
}}>This will be visible to HR/recruitment team for future reference</p>
               </Row>
               <Row>
                <Input type="textarea" rows="4" placeholder="Comments" style={{border:"1px solid #475467"}} />
               </Row>
                </Col>
            </Row>
            <Row className='mt-4'>
                <Col>
               <Row className=''>
               <p style={{
  fontWeight: 500,
  fontSize: '14px',

  }}>
                Feedback to Candidates
                </p>
            
               </Row>
               <Row>
                <Input type="textarea" rows="4" placeholder="Feedback" style={{border:"1px solid #475467",}} />
               </Row>
                </Col>
            </Row>
            <Row className='mt-4'>
                <Col>
                <FormGroup className='d-flex gap-2 align-items: center'>
                    <Input id='6' className='checkbox' type="checkbox" style={{border:"1px solid #475467"}} />
                        <Label for='6' style={{
                            fontFamily: 'Inter, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                            // lineHeight: '22px',
                            // letterSpacing: '0%'
                        }}>Send rejection email to candidates</Label>
                    </FormGroup>
                    <FormGroup className='d-flex gap-2 align-items: center'>
                    <Input id='7' className='checkbox' type="checkbox" style={{border:"1px solid #475467"}} />
                        <Label for='7' style={{
                            fontFamily: 'Inter, sans-serif',
                            fontWeight: 500,
                            fontSize: '14px',
                            // lineHeight: '22px',
                            // letterSpacing: '0%'
                        }}>Do not notify candidates</Label>
                    </FormGroup></Col>
            </Row>
            
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '24px' }}>
                <Button className='text-primary border-primary'
                    onClick={closeModal}
                    style={{
                        backgroundColor: 'white',
                        // color: 'primary',
                        border: '1px solid primary',
                        borderRadius: '12px',
                        marginRight: '16px',
                        width:"128px"

                    }}
                >
                    Cancel
                </Button>
                {/* <Button
                    // onClick={handleContinue}
                    style={{
                        backgroundColor: '#006438',
                        color: '#FFFFFF',
                        borderRadius: '12px',
                        width:"128px"
                    }}
                >
                    Submit
                </Button> */}
                <CustomButton text={"Submit"}/>
                
                
             </div>


        </div>
    );
};

export default RejectCandidate
    ;


{/* 
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '24px' }}>
                <Button
                    onClick={closeModal}
                    style={{
                        backgroundColor: 'white',
                        color: '#006438',
                        border: '1px solid #006438',
                        borderRadius: '12px',
                        marginRight: '16px'
                    }}
                >
                    Cancel
                </Button>
                <Button
                    // onClick={handleContinue}
                    style={{
                        backgroundColor: '#006438',
                        color: '#FFFFFF',
                        borderRadius: '12px'
                    }}
                >
                    Close Ticket
                </Button>
            </div> */}